import React from 'react';

const LinkedIn = ({ className = '' }: { className?: string }): JSX.Element => {
	return (
		<svg
			className={className}
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 19.882 19.882">
			<path
				d="M18.462 0H1.416A1.426 1.426 0 0 0 0 1.433V18.45a1.426 1.426 0 0 0 1.416 1.433h17.046a1.43 1.43 0 0 0 1.42-1.433V1.433A1.43 1.43 0 0 0 18.462 0ZM6.009 17.042H3.062V7.55h2.951v9.488ZM4.536 6.257A1.709 1.709 0 1 1 6.244 4.55a1.709 1.709 0 0 1-1.708 1.707Zm12.519 10.785h-2.947v-4.616c0-1.1-.022-2.516-1.531-2.516-1.536 0-1.771 1.2-1.771 2.436v4.7H7.86V7.55h2.827v1.3h.04a3.1 3.1 0 0 1 2.791-1.531c2.982 0 3.537 1.966 3.537 4.522Z"
				fill="currentColor"
			/>
		</svg>
	);
};

export default LinkedIn;
